<template>
  <div style="background-color: #03aaea; height: 100%">
    <div class="loginBody">
      <div class="centerBox">
        <img class="login_logo" src="../assets/login_logo.png" alt="" />
        <div class="loginBox">
          <img class="codeQr" src="../assets/codeQr.png" alt="" />
          <div class="checkLoginType">
            <div
              @click="checkLoginType(0)"
              :class="[loginType == 0 ? 'LoginActive' : '']"
            >
              密码登录 <span></span>
            </div>
            <div
              style="margin-left: 3vw"
              @click="checkLoginType(1)"
              :class="[loginType == 1 ? 'LoginActive' : '']"
            >
              免密码登录<span></span>
            </div>
          </div>

          <div class="inputBox">
            <div v-if="loginType == 1" style="color: #666; font-size: 0.2rem">
              中国+86
            </div>
            <img
              v-if="loginType == 1"
              src="../assets/arrowsUpDown.png"
              alt=""
            />
            <input
              type="password"
              style="width: 0; height: 0; border: 0; position: absolute"
              name="xx"
            />

            <input
              v-if="loginType == 1"
              style="height: 100%; font-size: 0.225rem"
              placeholder="请输入您的手机号
              "
              v-model="ruleForm2.account"
              autoComplete="off"
              type="text"
            />
            <input
              v-if="loginType == 0"
              style="height: 100%; font-size: 0.225rem"
              placeholder="请输入您的账号
              "
              v-model="ruleForm2.account"
              autoComplete="off"
              type="text"
            />
          </div>
          <div class="inputBox" v-if="loginType == 1">
            <input
              type="password"
              style="width: 0; height: 0; border: 0; position: absolute"
              name="xx"
            />
            <input
              style="height: 100%; font-size: 0.225rem"
              placeholder="输入6位短信验证码"
              v-model="ruleForm2.checkPass"
              autoComplete="off"
              type="text"
            />
            <div
              style="color: #3558b9; cursor: pointer"
              @click.stop="getVerifyCode"
            >
              {{ btnTitle }}
            </div>
          </div>
          <div class="inputBox" v-if="loginType == 0">
            <input
              type="password"
              style="width: 0; height: 0; border: 0; position: absolute"
              name="xx"
            />
            <input
              style="height: 100%; font-size: 0.225rem"
              placeholder="请输入密码"
              v-model="ruleForm2.checkPass"
              autoComplete="off"
              type="password"
            />
          </div>
          <!-- <el-checkbox v-model="checked" checked class="remember"
            >记住密码</el-checkbox
          > -->
          <div style="width: 100%">
            <el-button
              type="primary"
              @click.native.prevent="handleSubmit2"
              :loading="logining"
              class="loginBtn"
              style=""
            >
              {{ loginStr }}
            </el-button>

            <p class="hint">
              手机验证后自动登录，登录即代表同意<a
                href="https://yrtsedu.cn/htm/mgdyh.html"
                target="_blank"
                style="color: #666"
                >《蘑菇岛用户协议》</a
              >
              <a
                href="https://yrtsedu.cn/htm/mgdyh.html"
                target="_blank"
                style="color: #666"
                >《隐私保护协议》</a
              >
            </p>
            <div class="elsePlatform">
              <div>社交账号登录</div>
              <div class="Platform">
                <img src="../assets/weixin.png" alt="" />
                <span>微信</span>
              </div>
              <div class="Platform">
                <img src="../assets/qq.png" alt="" />
                <span>QQ</span>
              </div>
              <div class="Platform">
                <img src="../assets/weibo.png" alt="" />
                <span>微博</span>
              </div>
            </div>

            <div class="downLoadApp">
              <img src="../assets/logo.png" alt="" />
              <span>
                <a
                  href="http://www.mushroomisland.cn/app.html"
                  target="_blank"
                  style="color: #3558b9"
                  >下载蘑菇岛APP
                </a></span
              >
            </div>
          </div>
        </div>
        <div class="flex-center" style="padding-bottom: 0.65rem">
          <img
            src="../assets/logo-f1.png"
            style="width: 2.5125rem; height: 0.8375rem; padding: 0.65rem 0 0 0"
            alt=""
          />
          <img
            src="../assets/logo-f2.png"
            style="
              width: 2.5125rem;
              height: 0.8375rem;
              padding: 0.65rem 0 0 1.625rem;
            "
            alt=""
          />
          <img
            src="../assets/logo-f3.png"
            style="
              width: 2.5125rem;
              height: 0.8375rem;
              padding: 0.65rem 0 0 1.625rem;
            "
            alt=""
          />
          <img
            src="../assets/logo-f4.png"
            style="
              width: 2.5125rem;
              height: 0.8375rem;
              padding: 0.65rem 0 0 1.625rem;
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="foot">
      <p>
        <span>上海蘑菇岛教育科技有限公司</span>·<span
          ><a
            href="http://www.mushroomisland.cn/about.html"
            target="_blank"
            style="color: #fff"
            >关于我们</a
          ></span
        >·<span
          ><a
            href="http://www.mushroomisland.cn/app.html"
            target="_blank"
            style="color: #fff"
            >APP下载</a
          ></span
        >·<span>公司官网</span>·<span
          ><a
            href="http://www.mushroomisland.cn/"
            target="_blank"
            style="color: #fff"
            >http://www.mushroomisland.cn/</a
          ></span
        >
      </p>
      <p>
        <span>网络文化经营许可证 沪网文（2020）5607-385号</span>·<span
          >增值电信业务经营许可证 编号：沪B2-20201235</span
        ><span>广播电视节目制作经营许可证 编号：（沪）字第04154号</span>
      </p>
      <p>
        <span>侵权举报</span>·<span>违法和不良信息举报：021-8031 3322</span
        >·<span>举报邮箱：service@yrtsedu.cn</span>
      </p>
    </div>
    <el-dialog title="选择身份" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-radio-group v-model="userAdmin">
          <el-radio
            :label="item.uID"
            v-for="(item, index) in userAdminList"
            :key="index"
            >【{{ item.SchoolName }}】{{ item.IdentityName }}</el-radio
          >
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancle">取 消</el-button>
        <el-button type="primary" @click="onClickAdminSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  requestLogin,
  requestLoginMock,
  getUserByToken,
  getNavigationBar,
  GetTokenUserListByJWT5,
  GetShortCode,
} from "../api/api";

import router from "@/router";
import { filterAsyncRouter } from "@/router/index";

export default {
  data() {
    return {
      instance: "",
      loginStr: "登录",
      logining: false,
      loginingMock: false,
      ruleForm2: {
        account: "",
        checkPass: "",
        phone: "",
      },
      loginType: 0, //1免密码登录 1密码登录
      checked: true,
      btnTitle: "获取验证码",
      disabled: false,
      dialogVisible: false,
      userAdmin: "",
      userAdminList: [],
    };
  },
  methods: {
    onCancle() {
      this.dialogVisible = false;
      this.logining = false;
      this.loginStr = "登录";
    },
    onClickAdminSubmit() {
      if (this.userAdmin != "") {
        this.handleSubmit2();
      } else {
        this.$message({
          type: "error",
          message: "请选择登录身份",
        });
      }
    },
    async GetShortCode() {
      let res = await GetShortCode({
        Phone: this.ruleForm2.account,
      });
      if (res.data.success) {
        this.validateBtn();
        this.$message({
          type: "success",
          message: "发送成功",
        });
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    validatePhone() {
      //判断输入的手机号是否合法
      if (!this.ruleForm2.account) {
        this.$message({
          type: "error",
          message: "手机号码不能为空",
        });

        // return false
      } else if (!/^1[3456789]\d{9}$/.test(this.ruleForm2.account)) {
        this.$message({
          type: "error",
          message: "请输入正确手机号",
        });

        // return false
      } else {
        this.errors = {};
        return true;
      }
    },
    validateBtn() {
      //倒计时
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.disabled = false;
          this.btnTitle = "获取验证码";
        } else {
          this.btnTitle = time + "秒后重试";
          this.disabled = true;
          time--;
        }
      }, 1000);
    },
    getVerifyCode() {
      if (!this.disabled) {
        //获取验证码
        if (this.validatePhone()) {
          //发送网络请求
          this.GetShortCode();
        }
      } else {
        this.$message({
          type: "error",
          message: "不能重复点击",
        });
      }
    },
    checkLoginType(type) {
      this.loginType = type;
      this.ruleForm2 = {
        account: "",
        checkPass: "",
        phone: "",
      };
    },
    handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    loginAccount() {
      this.ruleForm2.account = "laozhang";
      this.ruleForm2.checkPass = "123456";
    },
    //这个是用来测试 mock 的，很简单，只需要在 main.js 中开启服务即可
    handleSubmitMock(ev) {
      var _this = this;
      // this.$refs.ruleForm2.validate((valid) => {

      // });
      this.loginingMock = true;
      var loginParams = {
        username: this.ruleForm2.account,
        password: this.ruleForm2.checkPass,
      };
      requestLoginMock(loginParams).then((data) => {
        this.loginingMock = false;
        if (data && data.code && data.msg) {
          _this.$message({
            message: data.code + data.msg + "，用户名admin,密码123456",
            type: "error",
          });
        } else {
          _this.$message({
            message: "测试mock，请在main.js 中开启服务!",
            type: "error",
          });
        }
      });
    },
    openAlert(msg) {
      this.instance = this.$notify({
        title: "提示",
        message: msg,
        duration: 0,
        position: "top-left",
      });
    },
    closeAlert() {
      this.instance.close();
    },
    // 获取 Token
    handleSubmit2(ev) {
      if (this.ruleForm2.account != "" && this.ruleForm2.checkPass != "") {
        window.localStorage.loginurl = "/login";
        var _this = this;
        // this.$refs.ruleForm2.validate((valid) => {
        //   if (valid) {
        this.logining = true;
        var loginParams = {
          name: this.ruleForm2.account,
          pass: this.ruleForm2.checkPass,
          Code: this.ruleForm2.checkPass,
          Type: this.loginType == 0 ? 1 : 0,
          uID: this.userAdmin,
        };

        _this.loginStr = "登录中...";

        requestLogin(loginParams).then((data) => {
          if (!data.success) {
            _this.$message({
              message: data.msg,
              type: "error",
            });
            _this.logining = false;
            _this.loginStr = "重新登录";
          } else {
            // 调用多重身份选择
            if (!data.response.success) {
              this.dialogVisible = true;
              GetTokenUserListByJWT5(loginParams).then((xhr) => {
                this.userAdminList = xhr.response;
                console.log(xhr, "asd");
              });
            } else {
              var token = data.response.token;
              _this.$store.commit("saveToken", token);
              var curTime = new Date();
              var expiredate = new Date(
                curTime.setSeconds(
                  curTime.getSeconds() + data.response.expires_in
                )
              );
              _this.$store.commit("saveTokenExpire", expiredate);
              window.localStorage.refreshtime = expiredate;
              window.localStorage.expires_in = data.response.expires_in;
              _this.getUserInfoByToken(token);
            }
          }
        });
      } else {
        this.$message({
          type: "error",
          message: "请输入账号密码",
        });
      }
      // } else {
      //   //console.log("error submit!!");
      //   return false;
      // }
      // });
    },
    // 获取用户数据
    getUserInfoByToken(token) {
      var _this = this;
      var loginParams = { token: token };
      getUserByToken(loginParams).then((data) => {
        if (!data.success) {
          _this.$message({
            message: data.msg,
            type: "error",
          });
        } else {
          window.localStorage.user = JSON.stringify(data.response);
          if (data.response.ParentId == -1) {
            this.$router.push({
              path: "/newCharts",
            });
          } else {
            // _this.loginStr = "接收到用户数据，开始初始化路由树...";
            if (data.response.uID > 0) {
              _this.getNavigationBar(data.response.uID);
            } else {
              _this.$message({
                message: "登录失败",
                type: "error",
              });
              this.loginStr = "重新登录";
            }
          }
        }
      });
    },
    // 获取路由树
    getNavigationBar(uid) {
      var _this = this;
      // var loginParams = { uid: uid, t: new Date() };
      var loginParams = { uid: uid };
      getNavigationBar(loginParams).then((res) => {
        _this.logining = false;

        if (!res.success) {
          _this.$message({
            message: res.msg,
            type: "error",
          });
          this.loginStr = "重新登录";
        } else {
          // _this.closeAlert()
          _this.$message({
            message: "后台初始化成功",
            type: "success",
          });
          let userinfo = JSON.parse(
            window.localStorage.user ? window.localStorage.user : null
          );
          _this.$notify({
            type: "success",
            message: `登录成功 \n 欢迎管理员：${userinfo.SchoolName}`,
            duration: 6000,
          });
          let getRouter = res.response.children; //后台拿到路由
          window.localStorage.router = JSON.stringify(res.response.children);
          getRouter = filterAsyncRouter(getRouter); //过滤路由
          router.$addRoutes(getRouter); //动态添加路由
          _this.$router.replace("/");
        }
      });
    },
  },
  mounted() {
    window.localStorage.clear();
  },
};
</script>
<style lang="less" scoped>
.downLoadApp {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3vw;
  background-color: #f6f6f6;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  img {
    width: 22px;
    height: auto;
  }
  span {
    color: #3558b9;
    padding-left: 0.125rem;
    font-size: 0.175rem;
    font-weight: bold;
  }
}
.elsePlatform {
  padding-top: 1vw;
  padding-bottom: 2vw;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  div:nth-child(1) {
    font-size: 15px;
    font-weight: 400;
    color: #999999;
    padding-right: 27px;
  }

  .Platform {
    display: flex;
    align-items: center;
    img {
      height: 15px;
      width: auto;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      margin-left: 5px;
    }
  }
}
.hint {
  font-size: 0.175rem;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  padding-top: 1vw;
  padding-bottom: 14px;
  border-bottom: #eaeaea solid 1px;
}
.inputBox {
  height: 3vw;
  border-bottom: #eaeaea solid 1px;
  display: flex;
  align-items: center;
  font-size: 1vw;
  color: #999999;
  input {
    background: none;
    outline: none;
    border: none;
    flex: 1;
    display: block;
    width: 3vw;
  }
  img {
    width: 8px;
    height: auto;
    display: block;
    margin-left: 20px;
    margin-right: 20px;
  }
  input:focus {
    border: none;
  }
  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    font-size: 1vw;
    color: #999999;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    font-size: 1vw;
    color: #999999;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    font-size: 1vw;
    color: #999999;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    font-size: 1vw;
    color: #999999;
  }
}

.loginBtn {
  margin-top: 2vw;
  width: 100%;
  height: 2vw;
  background: #3558b9;
  line-height: 2vw;
  padding: 0;
}
.checkLoginType {
  display: flex;
  div {
    position: relative;
    color: #666666;
    font-size: 1vw;
    font-weight: 400;
    transition: all 500ms;
    cursor: pointer;
    padding-bottom: 0.5vw;
    margin-bottom: 2vw;
    span {
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 2px;
      background: #3558b9;
      transform: translateX(-50%);
      transition: width 300ms;
    }
  }
  .LoginActive {
    font-weight: bold;
    color: #333333;
    span {
      width: 80%;
    }
  }
}
.centerBox {
  .login_logo {
    display: block;
    width: 13vw;
    height: auto;
    margin: 0 auto;
    padding-top: 0.375rem;
  }
}
.loginBox {
  margin: 0 auto;
  margin-top: 2vw;
  width: 6rem;
  min-width: 3.25rem;
  // min-height: 300px;
  // height: 28vw;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(38, 130, 221, 1);
  border-radius: 2px 2px 2px 2px;
  opacity: 1;
  box-sizing: border-box;
  padding: 0.425rem 0.5125rem;
  position: relative;
  .codeQr {
    position: absolute;
    width: 3vw;
    top: 0;
    right: 0;
  }
}
.loginBody {
  width: 100%;
  background-image: url(../assets/loginBg.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom right;
}
.foot {
  box-sizing: border-box;
  padding-top: 1vh;
  background-color: #03aaea;
  height: 10vh;
  text-align: center;
  font-size: 10px;
  line-height: 3vh;
  font-weight: 400;
  color: #ffffff;
}
</style>
